module.exports = __webpack_public_path__ + "static/img/task-guide-2026.f2933734.jpg";